module.exports = __webpack_public_path__ + "img/Weapon_185.5ab97160.png";